import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import {minDate} from '../../Constants/Constants'
const AddOfficeUtils = ({ formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [staff, setStaff] = useState([]);
  const [personName, setPersonName] = useState("");
  const [mobNumber, setMobNumber] = useState("");
  const [company, setCompany] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [rowAddData, setRowAddData] = useState({
    staff_id: "",
    company_id: "",
    received_date: "",
    pc_name: "",
    printer_name: "",
    specification: "",
    warrenty_guarantee: "",
    status_remark: "",
    mob_num: "",
  });

  function resetFields() {
    setRowAddData({
      staff_id: "",
      company_id: "",
      received_date: "",
      pc_name: "",
      printer_name: "",
      specification: "",
      warrenty_guarantee: "",
      status_remark: "",
      mob_num:""
    });
    setCompanyId("");
    setMobNumber("");
    setPersonName("");
  }

  const getStaff = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setStaff(result.data);
  };

  useEffect(() => {
    if (companyId) {
      getStaff();
    }
  }, [companyId]);

  const handleOfficeUtils = (e) => {
    const selectedStaffId = e.target.value;
    const selectedStaff = staff.find(
      (item) => item.id.toString() === selectedStaffId
    );
    if (selectedStaff) {
      setPersonName(selectedStaff.id);
      setMobNumber(selectedStaff.mob_num);
    } else {
      setPersonName("");
      setMobNumber("");
    }
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setCompanyId(value ? value : "");
    setStaff([]);
    setPersonName("");
    setMobNumber("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      received_date,
      pc_name,
      printer_name,
      specification,
      warrenty_guarantee,
      status_remark,
      mob_num,
    } = rowAddData;

    const from_date = moment(received_date, "YYYY-MM-DD");

    let BASE_URL =
      SERVER_URL + `/api/officeUtils/officeUtils-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        staff_id: personName,
        company_id: companyId,
        received_date: from_date,
        pc_name,
        printer_name,
        specification,
        warrenty_guarantee,
        status_remark,
        mob_num,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        resetFields();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (mobNumber) {
      setRowAddData((prevData) => ({ ...prevData, mob_num: mobNumber }));
    }
  }, [mobNumber]);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="officeModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Office Equipment
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="received_date">Received Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="received_date"
                              id="received_date"
                              placeholder="Received Date"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.received_date}
                              // min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Quantity">PC Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="pc_name"
                              id="Quantity"
                              placeholder="PC Name"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.pc_name}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Size">Printer</label>
                            <input
                              type="text"
                              className="form-control"
                              name="printer_name"
                              id="Size"
                              placeholder="Printer"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.printer_name}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={companyId}
                              required
                              id="company_id"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Person">Person</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleOfficeUtils}
                              value={personName}
                              required
                              id="Person"
                            >
                              <option value="">Select Person</option>
                              {staff &&
                                staff.length > 0 &&
                                staff.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >{`${item.staff_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="mob">Mob. Number</label>
                            <input
                              id="mob"
                              type="text"
                              name="mob_num"
                              className="form-control"
                              value={rowAddData.mob_num}
                              placeholder="Mob. Number"
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Specification">Specification</label>
                            <input
                              type="text"
                              className="form-control"
                              name="specification"
                              id="Specification"
                              placeholder="Specification"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.specification}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="warrenty_guarantee">
                              Warrenty Guarrenty
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="warrenty_guarantee"
                              id="warrenty_guarantee"
                              placeholder="Warrenty Guarrenty"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.warrenty_guarantee}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="status_remark">Status Remark</label>
                            <input
                              type="text"
                              className="form-control"
                              name="status_remark"
                              id="status_remark"
                              placeholder="Status Remark"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.status_remark}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddOfficeUtils;
